<template>
  <div class='reportSwitch'>
    <el-switch v-model="dataValue.open"
               @change="handleChange">
    </el-switch>
    <skySelect v-model="dataValue.id"
               v-bind="$attrs"
               @change="handleChange"></skySelect>
  </div>
</template>

<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';

export default {
  name: 'reportSwitch',
  props: {
    value: {
      default: null,
      required: true
    },
  },
  components: {
    skySelect
  },
  data () {
    return {
      dataValue: {
        open: '',
        id: ''
      },
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.dataValue = {
          open: val[0],
          id: val[1]
        };
      },
      immediate: true
    },
  },
  methods: {
    handleChange () {
      let { open, id } = this.dataValue
      this.$emit('input', [open, id]);
    }
  }
}
</script>

<style lang='scss' scoped>
.reportSwitch {
	display: flex;
	flex-direction: column;
	margin-top: 10px;

	.el-switch {
		margin-bottom: 10px;
	}
}
</style>
